import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-secondary-red"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "tooltip-wrapper d-flex align-items-end"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "arrows"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 4,
  class: "select-items checkbox-items"
}
const _hoisted_15 = {
  key: 0,
  class: "select-option"
}
const _hoisted_16 = { class: "select-option" }
const _hoisted_17 = ["id", "value"]
const _hoisted_18 = ["for"]
const _hoisted_19 = {
  key: 0,
  class: "divider"
}
const _hoisted_20 = {
  key: 5,
  class: "text-secondary-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['custom-select links', _ctx.customClass, { 'error': _ctx.error }]),
    ref: "dropdownRef"
  }, [
    (_ctx.errorPlacement == 'top' && _ctx.error?.length)
      ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(Array.isArray(_ctx.error)  ? _ctx.error?.join('. ') : _ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 1,
          class: "body-text d-flex gap-5",
          for: _ctx.label
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " * "))
            : _createCommentVNode("", true),
          (_ctx.instructions)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("p", {
                  innerHTML: _ctx.instructions,
                  class: "tooltip-text tooltip-text_secondary tooltip-text__large tooltip-text__bottom tooltip-text__left"
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.displayedOptions?.length && _ctx.type !== 'filters')
      ? (_openBlock(), _createBlock(_component_Multiselect, {
          key: 2,
          modelValue: _ctx.internalSelectedOption,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSelectedOption) = $event)),
          options: _ctx.displayedOptions,
          placeholder: "Type to search",
          searchable: true,
          "close-on-select": true,
          "track-by": "key",
          onSearchChange: _ctx.handleSearch,
          label: "value",
          disabled: _ctx.readonly
        }, null, 8, ["modelValue", "options", "onSearchChange", "disabled"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'filters')
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['select-selected filter-arrows', { 'error': _ctx.error }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
        }, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.internalSelectedOption.value), 1),
          (_ctx.singleArrow && !_ctx.isSearchable)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["arrows", { 'single': _ctx.singleArrow }])
              }, _hoisted_9, 2))
            : (!_ctx.isSearchable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isDropdownOpen && !_ctx.readonly && _ctx.type === 'filters')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (!_ctx.displayedOptions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No options "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedOptions, (option, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: option.key
            }, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: `option-${option.key}`,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedOptions) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                  value: option.key
                }, null, 40, _hoisted_17), [
                  [_vModelCheckbox, _ctx.checkedOptions]
                ]),
                _createElementVNode("label", {
                  for: `option-${option.key}`
                }, _toDisplayString(option.value), 9, _hoisted_18)
              ]),
              (index < _ctx.displayedOptions.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorPlacement == 'bottom' && _ctx.error?.length)
      ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(Array.isArray(_ctx.error)  ? _ctx.error?.join('. ') : _ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}